export const SUPPORTED_TAGS = ['strong', 'em', 'a', 'span', 'blockquote', 'ul', 'ol', 'li', 'p'];

/**
 * This function ensures that any HTML-like text that isn't explicitly allowed is rendered
 * as plain text in the browser, preventing it from being treated as an active HTML element.
 *
 * @param {string} input - The string containing potential HTML tags to be escaped.
 * @returns {string} - The transformed string with unsupported HTML tags escaped.
 *
 * Example:
 *   const safeText = escapeUnsupportedTags("<div>hello</div> <strong><exploding vests are the best>world</strong>");
 *   // Output: "&lt;div&gt;hello&lt;/div&gt; <strong><exploding vests are the best>world</strong>"
 */
export function escapeUnsupportedTags(input) {
  const tagRegex = /<\/?([a-zA-Z]+)[^>]*>/g;
  return input.replace(tagRegex, (match, tagName) => {
    if (!SUPPORTED_TAGS.includes(tagName.toLowerCase())) {
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    return match;
  });
}
